export default __webpack_public_path__ + "static/media/about_one.6de2fc35.jpg";